import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "../lib/api";

let cache = null;
let inflight = null;

const DAY_NAMES = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];

export function loadTeamWorkdays() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api
      .get("/teams/workdays")
      .then((r) => (cache = r.data || {}))
      .catch(() => ({}))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useTeamWorkdays() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    let alive = true;
    loadTeamWorkdays().then((m) => alive && setMap(m));
    return () => { alive = false; };
  }, []);
  return map;
}

function toDate(value) {
  if (value instanceof Date) return value;
  const s = String(value || "");
  return new Date(s.length === 10 ? `${s}T12:00:00` : s);
}

export function isOffDay(map, teamId, value) {
  const days = map?.[teamId];
  if (!teamId || !days || !value) return false;
  const d = toDate(value);
  return !Number.isNaN(d.getTime()) && !days.includes(d.getDay());
}

export async function confirmOffDay(confirm, teamId, value, teamName) {
  const map = await loadTeamWorkdays();
  if (!isOffDay(map, teamId, value)) return true;
  return confirm({
    title: "Dia fora do normal da equipe",
    description: `${teamName || "Esta equipe"} normalmente não trabalha ${DAY_NAMES[toDate(value).getDay()]}. Deseja agendar mesmo assim?`,
    actionLabel: "Agendar mesmo assim",
  });
}

export function OffDayIcon({ size = 12, className = "", testId }) {
  return (
    <AlertTriangle
      size={size}
      className={`text-red-600 shrink-0 ${className}`}
      fill="#fde68a"
      strokeWidth={2.5}
      data-testid={testId}
      aria-label="Dia fora do normal da equipe"
    >
      <title>Dia fora do normal da equipe</title>
    </AlertTriangle>
  );
}

